export default {
  SET_USER_DATA(userData = {}) {
    console.debug('Try setting mouseflow data')
    let count = 3
    let timeout = null
    ;(function checkMouseflow() {
      console.debug('checkMouseflow called!')
      if (
        typeof window.mouseflow !== 'undefined' &&
        window.mouseflow.isRecording()
      ) {
        console.debug('Mouseflow tagged')
        window._mfq = window._mfq || []
        window._mfq.push([
          'setVariable',
          'USER_TAG',
          'Success',
          'session',
          false
        ])
        if (userData && userData.id) {
          window._mfq.push([
            'setVariable',
            'USER_ID',
            userData.id,
            'session',
            false
          ])
        }
        if (userData && userData.name) {
          window._mfq.push([
            'setVariable',
            'USER_NAME',
            userData.name,
            'session',
            false
          ])
        }
        if (userData && userData.business_id) {
          window._mfq.push([
            'setVariable',
            'BUSINESS_ID',
            userData.business_id,
            'session',
            false
          ])
        }
      } else {
        if (count > 0) {
          console.debug('Mouseflow retried')
          count = count - 1
          timeout = setTimeout(() => checkMouseflow(count), 3000)
        } else {
          console.debug('Mouseflow failed!')
          window._mfq.push([
            'setVariable',
            'USER_TAG',
            'Failed',
            'session',
            false
          ])
          timeout && clearTimeout(timeout)
        }
      }
    })()
  }
}
